exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-be1b3f84]{flex:1 1 0%;border-top-width:1px;border-bottom-width:1px;--tw-border-opacity:1;border-color:rgb(128 128 128/var(--tw-border-opacity));background-color:transparent;--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity));padding-top:.75rem;padding-bottom:.75rem;padding-left:2.5rem;outline:2px solid transparent;outline-offset:2px}input[data-v-be1b3f84]::-moz-placeholder{font-weight:400;--tw-text-opacity:1;color:rgb(128 128 128/var(--tw-text-opacity))}input[data-v-be1b3f84]::placeholder{font-weight:400;--tw-text-opacity:1;color:rgb(128 128 128/var(--tw-text-opacity))}", ""]);

// exports
